import { useFormContext } from 'context/FormContext';
import { useMutateColunasDinamicas } from 'pages/cadastro/colunas-dinamicas/hooks/useMutateColunasDinamicas';
import { OpcaoProps } from 'pages/cadastro/loja/types';

export function useGetColunasOpcoes(filterValue: string) {
    const { content } = useFormContext();
    const { onSubmitForm } = useMutateColunasDinamicas();

    const originalList = content?.configuracaoPropriedadeOpcaoList || [];

    const filteredList = originalList.filter(
        (item: OpcaoProps) =>
            !filterValue ||
            item.dsConfiguracaoPropriedadeOpcao.toLowerCase().includes(filterValue.toLowerCase()) ||
            item.idConfiguracaoPropriedadeOpcao == Number(filterValue),
    );
    const handleRemoveOption = (idParaRemover: number) => {
        const updatedList = content.configuracaoPropriedadeOpcaoList.filter(
            (opcao: OpcaoProps) => opcao.idConfiguracaoPropriedadeOpcao !== idParaRemover,
        );

        onSubmitForm({
            ...content,
            configuracaoPropriedadeOpcaoList: updatedList,
        });
    };

    const handleEditOption = (opcaoEditada: OpcaoProps | null) => {
        const novaLista = filteredList.map((item: OpcaoProps) => {
            if (item.idConfiguracaoPropriedadeOpcao === opcaoEditada?.idConfiguracaoPropriedadeOpcao) {
                return { ...item, ...opcaoEditada };
            }
            return item;
        });
        onSubmitForm({
            ...content,
            configuracaoPropriedadeOpcaoList: novaLista,
        });
    };

    const handleSaveOption = (opcaoData: OpcaoProps | null) => {
        const opcaoExiste = filteredList.some((item: any) => item.idConfiguracaoPropriedadeOpcao === opcaoData?.idConfiguracaoPropriedadeOpcao);

        if (opcaoExiste && opcaoData?.idConfiguracaoPropriedadeOpcao) {
            handleEditOption(opcaoData);
        } else {
            onSubmitForm({
                ...content,
                configuracaoPropriedadeOpcaoList: [...(content.configuracaoPropriedadeOpcaoList || []), opcaoData],
            });
        }
    };

    return { filteredList, handleSaveOption, handleRemoveOption };
}
